module.exports = __webpack_public_path__ + "static/img/bcg_k4.912ae944.png";